/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PostBundleRequest } from '../../models/post-bundle-request';
import { PostBundleResponse } from '../../models/post-bundle-response';

export interface PostNewBundle$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: PostBundleRequest
}

export function postNewBundle(http: HttpClient, rootUrl: string, params: PostNewBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<PostBundleResponse>> {
  const rb = new RequestBuilder(rootUrl, postNewBundle.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PostBundleResponse>;
    })
  );
}

postNewBundle.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles';
